import { GrantRole, OrganizationRoleType } from "../../../../autogen/bff-api";

const PAIRS: [GrantRole, OrganizationRoleType][] = [
  [GrantRole.Owner, OrganizationRoleType.Owner],
  [GrantRole.Admin, OrganizationRoleType.Admin],
  [GrantRole.SourcingCreator, OrganizationRoleType.SourcingCreator],
  [GrantRole.SourcingViewer, OrganizationRoleType.SourcingViewer],
  [GrantRole.ContractCreator, OrganizationRoleType.ContractCreator],
  [GrantRole.ContractViewer, OrganizationRoleType.ContractViewer],
  [GrantRole.ProjectCreator, OrganizationRoleType.ProjectCreator],
  [GrantRole.ProjectViewer, OrganizationRoleType.ProjectViewer],
];

const toOrganizationRole = new Map<GrantRole, OrganizationRoleType>(PAIRS);
const toGrantRole = new Map<OrganizationRoleType, GrantRole>(PAIRS.map(([g, o]) => [o, g]));

export const asOrganizationRole = (role: GrantRole): OrganizationRoleType | null =>
  toOrganizationRole.get(role) ?? null;

export const asGrantRole = (role: OrganizationRoleType): GrantRole | null => toGrantRole.get(role) ?? null;

export const isSameRole = (grantRole: GrantRole, organizationRole: OrganizationRoleType): boolean =>
  toOrganizationRole.get(grantRole) === organizationRole;
